module.exports = __webpack_public_path__ + "static/media/Tanya Laramie.8b72cfef.png";